module.exports = "/_next/static/images/customer-review-sarah1@2x-min-90245ee63239ffcb235b60a4fdc4bf4c.png";